import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  WorkProseBlock,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function SaackeScrubber() {
  const ProjectBG = require("../../../../assets/videos/saacke-scrubber/poster.png");
  const T1 = require("../../../../assets/videos/saacke-scrubber/t1.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="Saacke Scrubber — exhaust gas cleaning simulation"
      lead={
        <p>
          Desktop application for Saacke GmbH: explore how the exhaust gas
          cleaning system behaves in a clear, interactive simulation.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/saacke-scrubber/1_SaackeScrubber.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Two operating modes</WorkSectionHeading>
          <p>
            Compare open-loop and closed-loop behavior and their effect on a
            large vessel in international waters.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkProseBlock>
        <WorkSectionHeading>Realistic simulation</WorkSectionHeading>
        <p>
          Mechanisms and processes are represented with faithful visuals so
          stakeholders grasp system behavior quickly.
        </p>
      </WorkProseBlock>

      <WorkProseBlock>
        <WorkSectionHeading>Comprehensive learning</WorkSectionHeading>
        <p>
          Principles, technical detail, and advantages of Saacke scrubbers
          through intuitive graphics, text, and interaction.
        </p>
      </WorkProseBlock>

      <ConcludeContainer>
        <p>
          Built exclusively for Saacke GmbH—not publicly distributed—focused on
          maritime sustainability and education.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "Saacke Scrubber" },
          { label: "Period", value: "10.2020 - 11.2020" },
          { label: "Client", value: "Saacke" },
          { label: "Engine & Tools", value: "Unity, C#" },
          { label: "Platform", value: "PC, Web" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "Web, Desktop" },
        ]}
      />
    </WorkProjectShell>
  );
}
